import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45780c78"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "inline-flex items-center mt-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "¿Es recargable?")
], -1))
const _hoisted_3 = { class: "flex justify-center" }
const _hoisted_4 = { class: "inline-flex items-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-2 mr-4" }, "Si", -1))
const _hoisted_6 = { class: "inline-flex items-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "No", -1))
const _hoisted_8 = { class: "flex flex-col" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "inline-flex items-center mt-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "¿Esta certificado?")
], -1))
const _hoisted_10 = { class: "flex justify-center" }
const _hoisted_11 = { class: "inline-flex items-center" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-2 mr-4" }, "Si", -1))
const _hoisted_13 = { class: "inline-flex items-center" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "No", -1))
const _hoisted_15 = { class: "flex justify-between mt-4" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  key: 1,
  class: "icon-spin"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1))
const _hoisted_20 = [
  _hoisted_19
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Selector = _resolveComponent("Selector")!
  const _component_TextField = _resolveComponent("TextField")!
  const _component_Alert = _resolveComponent("Alert")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_ModalAlert = _resolveComponent("ModalAlert")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Modal, {
      title: "Agregar Extintor",
      visible: _ctx.showModal,
      "onUpdate:visible": _cache[8] || (_cache[8] = (e) => _ctx.$emit('update:visible', e))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Selector, {
          selectedItem: _ctx.tipo,
          label: 'Tipo de Extintor',
          class: "w-full gap-4",
          items: _ctx.buildingTypes,
          onUpdate: _ctx.onUpdateModel
        }, null, 8, ["selectedItem", "items", "onUpdate"]),
        _createVNode(_component_TextField, {
          label: "Descripción",
          model: _ctx.descripcion,
          "onUpdate:model": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.descripcion) = $event)),
          type: "textarea",
          name: "descripcion"
        }, null, 8, ["model"]),
        _createVNode(_component_TextField, {
          label: "Fecha Vencimiento",
          model: _ctx.vencimiento,
          "onUpdate:model": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.vencimiento) = $event)),
          type: "date",
          name: "vencimiento"
        }, null, 8, ["model"]),
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("label", _hoisted_4, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                class: "form-radio",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.recargable) = $event)),
                value: "true"
              }, null, 512), [
                [_vModelRadio, _ctx.recargable]
              ]),
              _hoisted_5
            ]),
            _createElementVNode("label", _hoisted_6, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                class: "form-radio",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.recargable) = $event)),
                value: "false"
              }, null, 512), [
                [_vModelRadio, _ctx.recargable]
              ]),
              _hoisted_7
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("label", _hoisted_11, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                class: "form-radio",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.certificado) = $event)),
                value: "true"
              }, null, 512), [
                [_vModelRadio, _ctx.certificado]
              ]),
              _hoisted_12
            ]),
            _createElementVNode("label", _hoisted_13, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                class: "form-radio",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.certificado) = $event)),
                value: "false"
              }, null, 512), [
                [_vModelRadio, _ctx.certificado]
              ]),
              _hoisted_14
            ])
          ])
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", null, [
          (_ctx.showAlert)
            ? (_openBlock(), _createBlock(_component_Alert, {
                key: 0,
                type: _ctx.type,
                message: _ctx.message
              }, null, 8, ["type", "message"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("button", {
            class: "px-4 py-2 mr-2 rounded-md bg-gray-300 hover:bg-gray-400 focus:bg-gray-400",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.cancelModal && _ctx.cancelModal(...args)))
          }, "Cancelar"),
          _createElementVNode("button", {
            class: "px-4 py-2 rounded-md bg-primary text-white hover:bg-green-600 focus:bg-green-600",
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.saveExtinguisher && _ctx.saveExtinguisher(...args))),
            disabled: _ctx.loading
          }, [
            (!_ctx.loading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_17, "Agregar"))
              : (_openBlock(), _createElementBlock("span", _hoisted_18, _hoisted_20))
          ], 8, _hoisted_16)
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_ModalAlert, {
      message: _ctx.message,
      visible: _ctx.showModalAlert,
      option: true,
      onAccept: _ctx.cancelModal
    }, null, 8, ["message", "visible", "onAccept"])
  ]))
}